import {gatewayRequest} from './supabaseGateway';

const SESSION_KEYS=['summer_session','summer_session_expires','summer_name','summer_email','summer_role'] as const;

export type CommunityAuthSession={
 token:string;
 name:string;
 email:string;
 role:string;
 expires_at?:string;
 access_code?:string;
};

function asRecord(value:unknown):Record<string,unknown>|null{
 return value&&typeof value==='object'&&!Array.isArray(value)?value as Record<string,unknown>:null;
}
function required(value:unknown,label:string):string{
 if(typeof value!=='string'||!value.trim())throw new Error(`${label} fehlt in der Antwort.`);
 return value.trim();
}
function parseSession(value:unknown):CommunityAuthSession{
 const item=asRecord(value);
 if(!item)throw new Error('Die Zugangsdaten konnten nicht gelesen werden.');
 return{
  token:required(item.token,'Sitzung'),
  name:required(item.name,'Name'),
  email:required(item.email,'E-Mail'),
  role:required(item.role,'Rolle'),
  expires_at:typeof item.expires_at==='string'?item.expires_at:undefined,
  access_code:typeof item.access_code==='string'?item.access_code:undefined,
 };
}
function persist(session:CommunityAuthSession):CommunityAuthSession{
 localStorage.setItem('summer_session',session.token);
 localStorage.setItem('summer_name',session.name);
 localStorage.setItem('summer_email',session.email);
 localStorage.setItem('summer_role',session.role);
 if(session.expires_at)localStorage.setItem('summer_session_expires',session.expires_at);
 else localStorage.removeItem('summer_session_expires');
 return session;
}
async function authenticate(path:string,body:Record<string,unknown>):Promise<CommunityAuthSession>{
 const payload=await gatewayRequest<unknown>(`/functions/v1/summer-intensive-auth${path}`,{
  method:'POST',body:JSON.stringify(body),
  fallbackMessage:'Der Zugang konnte nicht geöffnet werden.',
  networkMessage:'Die Verbindung zum Zugangsdienst konnte nicht hergestellt werden. Bitte lade die Seite neu und versuche es noch einmal.',
 });
 return persist(parseSession(payload));
}

export function hasCommunitySession():boolean{return Boolean(localStorage.getItem('summer_session'));}
export function clearCommunitySession():void{for(const key of SESSION_KEYS)localStorage.removeItem(key);}
export function loginCommunity(email:string,accessCode:string):Promise<CommunityAuthSession>{
 return authenticate('/login',{email:email.trim().toLowerCase(),access_code:accessCode.trim().toUpperCase()});
}
export function registerCommunity(name:string,email:string,inviteCode:string):Promise<CommunityAuthSession>{
 let clientKey=localStorage.getItem('summer_client_key')||'';
 if(!clientKey){clientKey=crypto.randomUUID();localStorage.setItem('summer_client_key',clientKey);}
 return authenticate('/register',{
  name:name.trim(),email:email.trim().toLowerCase(),invite_code:inviteCode.trim().toUpperCase(),legacy_client_key:clientKey,
 });
}
